import { CardCssClass as m } from "../Card.types.js";
import { PaddingSize as d } from "../../../enums.js";
import { c as i } from "../../../index-2QXL0WYc.js";
function p({
  className: a,
  clickable: e,
  padding: r = d.Md,
  selected: o,
  stretch: c
} = {}, t = {}) {
  const s = { ...m, ...t };
  return {
    className: i(
      s.Base,
      a,
      `${s.Padding}--${r}`,
      {
        [s.Stretch]: c,
        [s.Clickable]: e,
        [s.Selected]: o
      }
    )
  };
}
export {
  p as composeIDSCard
};
